import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './components/shared/not-found/not-found.component';
import { HomeComponent } from './components/main/home/home.component';
import { PrivacyComponent } from './components/shared/privacy/privacy.component';
import { PackagesDetailsComponent } from './components/shared/packages-details/packages-details.component';
import { TermsConditionsComponent } from './components/shared/terms-conditions/terms-conditions.component';
import { ExchangeReturnComponent } from './components/shared/exchange-return/exchange-return.component';



export const routes: Routes = [
  // Auth
  {
    path: 'auth',
    loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule)
  },
  // Account
  {
    path: 'account',
    loadChildren: () => import('./components/account/account.module').then(m => m.AccountModule)
  },
 

  // Main
  { path: '',
  loadChildren: () => import('./components/main/home/home.module').then(m => m.HomeModule)
  },
  // s-provider
  {
    path: 's-provider/:id',
    loadChildren: () => import('./components/service-provider/service-provider.module').then(m => m.ServiceProviderModule)
  },
  {
    path: 'privacy',
    component: PrivacyComponent
  },
  {
    path: 'packages-details',
    component: PackagesDetailsComponent
  },
  {
    path: 'terms-conditions',
    component: TermsConditionsComponent
  },
  {
    path: 'exchange-return',
    component: ExchangeReturnComponent
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'disabled',
  })
  ],
  exports: [RouterModule],

})
export class AppRoutingModule { }